{
    "DataTable_AreYouSure": "Möchten Sie Folgendes wirklich löschen? \n \n **{}**",
    "NAME": "LanguageDataTable",
    "DataTable_RowsPerPage": "Zeilen pro Seite",
    "DataTable_Of": "{}-{} of {}",
    "DataTable_Next": "Nächste Seite",
    "DataTable_Previous": "Vorherige Seite",
    "DataTable_OfMoreThan": "{}-{} von mehr als {}"
}